import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import BlockTypes from '../../types/BlockTypes';
import { normalizeNode, shouldBeAtRoot } from '../utils/NormalizationHelper';
import renderBlocks from '../utils/renderBlocks';
import makeToolbarButton, { BASIC_INSERTION, EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import makeKeyboardCommandShortcut from '../utils/makeKeyboardCommandShortcut';
import DatabaseEditorBlock from './DatabaseEditorBlock';
import { DatabaseIcon } from '../../components/Icons';
import provideLocalDatabaseSync from './provideLocalDatabaseSync';
var ANONYMOUS_USER_ID = 'anonymous';
export var schema = {
  blocks: _defineProperty({}, BlockTypes.DATABASE, {
    isVoid: true
  })
};
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$provideDatabaseS = _ref.provideDatabaseSync,
      provideDatabaseSync = _ref$provideDatabaseS === void 0 ? provideLocalDatabaseSync : _ref$provideDatabaseS,
      _ref$getCurrentUser = _ref.getCurrentUser,
      getCurrentUser = _ref$getCurrentUser === void 0 ? function () {
    return null;
  } : _ref$getCurrentUser,
      getUser = _ref.getUser,
      fetchNotes = _ref.fetchNotes,
      fetchUsers = _ref.fetchUsers,
      makeNoteLinkPlugin = _ref.makeNoteLinkPlugin,
      setActiveModal = _ref.setActiveModal;

  function getCurrentUserId() {
    return getCurrentUser() ? getCurrentUser().id : ANONYMOUS_USER_ID;
  }

  function canCreate() {
    return getCurrentUserId() !== ANONYMOUS_USER_ID;
  }

  return [normalizeNode(BlockTypes.DATABASE, [shouldBeAtRoot]), _objectSpread({
    schema: schema
  }, renderBlocks(_defineProperty({}, BlockTypes.DATABASE, function (props) {
    return React.createElement(DatabaseEditorBlock, Object.assign({}, props, {
      currentUserId: getCurrentUserId(),
      provideDatabaseSync: provideDatabaseSync,
      getUser: getUser,
      fetchNotes: fetchNotes,
      fetchUsers: fetchUsers,
      makeNoteLinkPlugin: makeNoteLinkPlugin,
      setActiveModal: setActiveModal
    }));
  })), {
    commands: {
      insertDatabase: function insertDatabase(editor) {
        editor.insertBlock({
          type: BlockTypes.DATABASE
        });
      }
    },
    queries: {
      isSelectionInDatabase: function isSelectionInDatabase(editor) {
        if (!editor.value.selection.isSet) {
          return false;
        }

        return editor.value.startBlock.type === BlockTypes.DATABASE || editor.value.endBlock.type === BlockTypes.DATABASE;
      }
    },
    onKeyDown: function onKeyDown(event, editor, next) {
      // Let databases handle the keyboard if focus in it
      if (!editor.isSelectionInDatabase()) {
        return next();
      }
    }
  }), makeToolbarButton(BlockTypes.DATABASE, {
    icon: DatabaseIcon,
    title: 'Database',
    alias: ['db'],
    visibility: BASIC_INSERTION | EXPANDED_INSERTION,
    canApply: function canApply(editor) {
      return canCreate() && editor.isMutableBlock();
    },
    isActive: function isActive(editor) {
      return editor.isActiveBlock(BlockTypes.DATABASE);
    },
    onApply: function onApply(editor) {
      return editor.command('insertDatabase');
    }
  }), makeKeyboardCommandShortcut('mod+shift+d', {
    type: BlockTypes.DATABASE,
    canApply: function canApply(editor) {
      return canCreate() && editor.isMutableBlock();
    },
    command: 'insertDatabase'
  })];
});